<script setup lang="ts">
import Topnav from '@/components/Topnav.vue'
import Maintenance from '@/components/Maintenance.vue'
import { useStore } from '@/store'
import { RouterWrapper } from '@bagelink/vue'
import { onMounted } from 'vue'

const store = useStore()

onMounted(store.initCart)
</script>

<template>
	<div>
		<!-- Maintenance Mode -->
		<Maintenance v-if="store.maintenanceMode" />
		
		<!-- Normal Site Content -->
		<template v-else>
			<ModalContainer />
			<!-- <Popup
			type="side" title="זה פופאפ" :countdown="0.01" body="תוכן של פופאפ כלשהו" image="/webclip.png"
			textColor="white" bgColor="red" btnTxt="אני כפתור" btnBgColor="white" btnTextColor="black" btnLink="#"
		/> -->
			<Topnav v-if="!$route.meta.hideMenu" />
			<RouterWrapper class="relative" />
		</template>
	</div>
</template>
